import _ from 'lodash';
import React from 'react';
import { connect as reactReduxConnect } from 'react-redux';
// @ts-expect-error
import VideoLayout from '../../../../../modules/UI/videolayout/VideoLayout';
import { appNavigate } from '../../../app/actions';
import { getConferenceNameForTitle } from '../../../base/conference/functions';
import { hangup } from '../../../base/connection/actions.web';
import { isMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n/functions';
import { setAudioMuted } from '../../../base/media/actions';
import { isAudioMuted } from '../../../base/media/functions';
import { showNotification } from '../../../notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from '../../../notifications/constants';
import { updateSettings } from '../../../base/settings/actions';
import { destroyLocalTracks } from '../../../base/tracks/actions.any';
import { setColorAlpha } from '../../../base/util/helpers';
import { getUserRole } from '../../../base/user-role/functions';
import { isLanguageQuickSwitchEnabled, isUnifiedRoomModel, isVrsApp } from '../../../base/whitelabel/functions';
import { LanguageSwitcher } from '../../../vrs-layout/components';
import PhoneNumpad from '../../../interpreter-phone/components/PhoneNumpad';
import VcoAudioControls from '../../../interpreter-phone/components/VcoAudioControls.web';
import { twilioVoiceService } from '../../../interpreter-phone/services/TwilioVoiceService';
import QueueStatusIndicator from '../../../interpreter-queue/components/web/QueueStatusIndicator';
import InMeetingRequestNotification from '../../../interpreter-queue/components/web/InMeetingRequestNotification';
import InterpreterStatusToggle from '../../../interpreter-queue/components/web/InterpreterStatusToggle';
import QueueStatsDashboard from '../../../interpreter-queue/components/web/QueueStatsDashboard';
import { queueService } from '../../../interpreter-queue/InterpreterQueueService';
import ShiftPanel from '../../../vrs-layout/components/ShiftPanel.web';
import VRSLayout, { isVrsSession } from '../../../vrs-layout/components/VRSLayout';
import AudioAutoplayPrompt from '../../../vrs-layout/components/web/AudioAutoplayPrompt.web';
import HandoffVideoProbe from '../../../device-handoff/components/HandoffVideoProbe.web';
import { HandoffProgress, InterpreterHandoffNotification, handoffService } from '../../../device-handoff';
import { startHandoffScanning, stopHandoffScanning } from '../../../device-handoff/actions';
import Chat from '../../../chat/components/web/Chat';
import { getWindowWidth, shouldDockInterpreterChat } from '../../../chat/interpreterChatDock';
import AudioTracksContainer from '../../../filmstrip/components/web/AudioTracksContainer';
import MainFilmstrip from '../../../filmstrip/components/web/MainFilmstrip';
import ScreenshareFilmstrip from '../../../filmstrip/components/web/ScreenshareFilmstrip';
import StageFilmstrip from '../../../filmstrip/components/web/StageFilmstrip';
import CalleeInfoContainer from '../../../invite/components/callee-info/CalleeInfoContainer';
import LargeVideo from '../../../large-video/components/LargeVideo.web';
import LobbyScreen from '../../../lobby/components/web/LobbyScreen';
import { getIsLobbyVisible } from '../../../lobby/functions';
import { getOverlayToRender } from '../../../overlay/functions.web';
import ParticipantsPane from '../../../participants-pane/components/web/ParticipantsPane';
import Prejoin from '../../../prejoin/components/web/Prejoin';
import { isPrejoinPageVisible } from '../../../prejoin/functions';
import ReactionAnimations from '../../../reactions/components/web/ReactionsAnimations';
import { toggleToolboxVisible } from '../../../toolbox/actions.any';
import VrsCaptionTools from './VrsCaptionTools';
import { fullScreenChanged, showToolbox } from '../../../toolbox/actions.web';
import JitsiPortal from '../../../toolbox/components/web/JitsiPortal';
import Toolbox from '../../../toolbox/components/web/Toolbox';
import { LAYOUT_CLASSNAMES } from '../../../video-layout/constants';
import { getCurrentLayout } from '../../../video-layout/functions.any';
import { recordingStarted } from '../../../voicemail/actions';
import { startVoicemailRecording } from '../../../voicemail/functions';
import InvitePanelWeb from '../../../vrs-layout/components/web/InvitePanel.web';
import { isPlatformCallRoomName } from '../../../vrs-layout/groupInvite';
import { getPersistentJson, hasPersistentAuthToken, removePersistentItem, setPersistentItem } from '../../../vrs-auth/storage';
import { init } from '../../actions.web';
import { maybeShowSuboptimalExperienceNotification } from '../../functions.web';
import { markJoin } from '../../joinMarks.web';
import { AbstractConference, abstractMapStateToProps } from '../AbstractConference';
import ConferenceInfo from './ConferenceInfo';
import { default as Notice } from './Notice';
/**
 * DOM events for when full screen mode has changed. Different browsers need
 * different vendor prefixes.
 *
 * @private
 * @type {Array<string>}
 */
const FULL_SCREEN_EVENTS = [
    'webkitfullscreenchange',
    'mozfullscreenchange',
    'fullscreenchange'
];
/**
 * The conference page of the Web application.
 */
class Conference extends AbstractConference {
    /**
     * Initializes a new Conference instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this._roomAudioNoticeShown = false;
        this._handoffRegistered = false;
        this._phoneListenersAttached = false;
        this._vcoAttemptStarted = false;
        this.state = {
            callStatus: 'idle',
            callError: undefined,
            connectionMessage: undefined,
            hangupPending: false,
            callDuration: ''
        };
        const { _mouseMoveCallbackInterval } = props;
        // Throttle and bind this component's mousemove handler to prevent it
        // from firing too often.
        this._originalOnShowToolbar = this._onShowToolbar;
        this._originalOnMouseMove = this._onMouseMove;
        this._onShowToolbar = _.throttle(() => this._originalOnShowToolbar(), 100, {
            leading: true,
            trailing: false
        });
        this._onMouseMove = _.throttle(event => this._originalOnMouseMove(event), _mouseMoveCallbackInterval, {
            leading: true,
            trailing: false
        });
        // Bind event handler so it is only bound once for every instance.
        this._onFullScreenChange = this._onFullScreenChange.bind(this);
        this._onVidespaceTouchStart = this._onVidespaceTouchStart.bind(this);
        this._setBackground = this._setBackground.bind(this);
        // Bind VRS phone handlers
        this._handleMakeCall = this._handleMakeCall.bind(this);
        this._handleHangupCall = this._handleHangupCall.bind(this);
        this._handleLeaveVoicemail = this._handleLeaveVoicemail.bind(this);
        this._handleStatusChange = this._handleStatusChange.bind(this);
        this._handleDurationUpdate = this._handleDurationUpdate.bind(this);
        this._handleSendDigits = this._handleSendDigits.bind(this);
    }
    /**
     * Start the connection and get the UI ready for the conference.
     *
     * @inheritdoc
     */
    componentDidMount() {
        markJoin('conferenceMount');
        document.title = interfaceConfig.APP_NAME;
        this._start();
        this._syncAuthenticatedDisplayName();
        if (this.props._accountRole === 'client' && isVrsApp() && isVrsSession(this.props._room)) {
            this._handoffRegistered = true;
            this.props.dispatch(startHandoffScanning());
            queueService.registerHandoffSession(this.props._room, handoffService.getDeviceId());
        }
        this._enforceVrsInterpreterRoomMute();
        // Set up Twilio voice service event listeners for interpreters
        if (this.props._accountRole === 'interpreter') {
            this._phoneListenersAttached = true;
            twilioVoiceService.on('statusChange', this._handleStatusChange);
            twilioVoiceService.on('durationUpdate', this._handleDurationUpdate);
            const currentPhoneStatus = twilioVoiceService.getCallStatus();
            this.setState({
                callStatus: currentPhoneStatus.status,
                callError: currentPhoneStatus.error,
                connectionMessage: currentPhoneStatus.connectionMessage,
                hangupPending: Boolean(currentPhoneStatus.hangupPending),
                callDuration: twilioVoiceService.getCallDuration()
            });
            if (this.props._vrsRequestKind === 'inbound_hearing'
                && !this.props._vrsVideoMailRelay
                && this.props._vrsTargetPhone
                && ['idle', 'ended', 'failed'].includes(currentPhoneStatus.status)) {
                void this._handleMakeCall(this.props._vrsTargetPhone);
            }
        }
        if (this.props._vcoEnabled) {
            this._vcoAttemptStarted = true;
            void this._joinVcoBridge();
        }
    }
    /**
     * Calls into legacy UI to update the application layout, if necessary.
     *
     * @inheritdoc
     * returns {void}
     */
    componentDidUpdate(prevProps) {
        this._enforceVrsInterpreterRoomMute();
        if (this.props._shouldDisplayTileView
            === prevProps._shouldDisplayTileView) {
            return;
        }
        // TODO: For now VideoLayout is being called as LargeVideo and Filmstrip
        // sizing logic is still handled outside of React. Once all components
        // are in react they should calculate size on their own as much as
        // possible and pass down sizings.
        VideoLayout.refreshLayout();
    }
    /**
     * On relay-model VRS calls the interpreter's voice belongs on the phone leg
     * (the Twilio connection captures the mic independently), never in the
     * room: the Deaf client should not receive interpreter audio. The
     * mount-time mute alone was not enough — a toolbar unmute re-opened room
     * audio — so re-assert the mute whenever it flips.
     *
     * Untouched on VRI and on unified-room tenants such as MalkaVCS: there both
     * parties are in the room and must hear the interpreter. The room-model
     * check comes first because MalkaVCS is a VRS-shaped app (`appType: vrs`)
     * that must not force this mute.
     *
     * @private
     * @returns {void}
     */
    _enforceVrsInterpreterRoomMute() {
        const { _audioMuted, _vrsCallType, dispatch } = this.props;
        if (isUnifiedRoomModel()) {
            return;
        }
        // Only trust an explicit call type. The old fallback inferred "this is
        // a phone-leg call" from a `vrs-` room-name prefix, but
        // vrs-room-generator.js emits that prefix for every room it creates,
        // so an unlabelled unified call would have silenced its interpreter.
        const isVrsPhoneSession = _vrsCallType === 'vrs';
        if (!isVrsApp() || this.props._accountRole !== 'interpreter' || !isVrsPhoneSession || _audioMuted) {
            return;
        }
        dispatch(setAudioMuted(true));
        if (!this._roomAudioNoticeShown) {
            this._roomAudioNoticeShown = true;
            dispatch(showNotification({
                title: 'Mic goes to the phone line',
                description: 'On VRS calls your voice reaches the hearing caller through the phone line. Room audio stays muted so the Deaf client does not hear you.'
            }, NOTIFICATION_TIMEOUT_TYPE.LONG));
        }
    }
    /**
     * Disconnect from the conference when component will be
     * unmounted.
     *
     * @inheritdoc
     */
    componentWillUnmount() {
        APP.UI.unbindEvents();
        FULL_SCREEN_EVENTS.forEach(name => document.removeEventListener(name, this._onFullScreenChange));
        // Clean up Twilio voice service listeners
        if (this._phoneListenersAttached) {
            twilioVoiceService.off('statusChange', this._handleStatusChange);
            twilioVoiceService.off('durationUpdate', this._handleDurationUpdate);
        }
        if (this._phoneListenersAttached || this._vcoAttemptStarted) {
            twilioVoiceService.cleanup();
        }
        if (this._handoffRegistered) {
            queueService.unregisterHandoffSession();
            this.props.dispatch(stopHandoffScanning());
        }
        APP.conference.isJoined() && this.props.dispatch(hangup());
        this.props.dispatch(destroyLocalTracks());
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { _isAnyOverlayVisible, _layoutClassName, _notificationsVisible, _overflowDrawer, _room, _showLobby, _showPrejoin, t } = this.props;
        const useVrsLayout = !_showPrejoin && !_showLobby && isVrsSession(_room);
        const interpreterWorkspace = useVrsLayout && this.props._accountRole === 'interpreter';
        return (React.createElement("div", { id: 'layout_wrapper', onMouseEnter: this._onMouseEnter, onMouseLeave: this._onMouseLeave, onMouseMove: this._onMouseMove, ref: this._setBackground },
            React.createElement(Chat, { key: `${_room}:${this.props._accountRole || 'guest'}`, persistent: interpreterWorkspace && this.props._dockInterpreterChat, interpreterTools: interpreterWorkspace ? React.createElement(React.Fragment, null,
                    React.createElement(QueueStatsDashboard, { docked: true }),
                    React.createElement("details", null,
                        React.createElement("summary", null, "Shift and availability"),
                        React.createElement(InterpreterStatusToggle, { docked: true }),
                        React.createElement(ShiftPanel, { docked: true }))) : undefined }),
            React.createElement("div", { className: `${_layoutClassName}${useVrsLayout ? ' vrs-stage' : ''}`, id: 'videoconference_page', onMouseMove: isMobileBrowser() ? undefined : this._onShowToolbar },
                React.createElement(ConferenceInfo, null),
                React.createElement(Notice, null),
                React.createElement("div", { id: 'videospace', onTouchStart: this._onVidespaceTouchStart },
                    useVrsLayout ? React.createElement(VRSLayout, null) : React.createElement(LargeVideo, null),
                    useVrsLayout && React.createElement(VrsCaptionTools, null),
                    useVrsLayout && React.createElement(AudioTracksContainer, null),
                    !useVrsLayout && !_showPrejoin && !_showLobby
                        && React.createElement(AudioAutoplayPrompt, { role: this.props._accountRole || 'guest' }),
                    _showPrejoin || _showLobby || useVrsLayout || (React.createElement(React.Fragment, null,
                        React.createElement(StageFilmstrip, null),
                        React.createElement(ScreenshareFilmstrip, null),
                        React.createElement(MainFilmstrip, null)))),
                _showPrejoin || _showLobby || (React.createElement(React.Fragment, null,
                    React.createElement("span", { "aria-level": 1, className: 'sr-only', role: 'heading' }, t('toolbar.accessibilityLabel.heading')),
                    React.createElement(Toolbox, null))),
                useVrsLayout && isPlatformCallRoomName(_room) && React.createElement(InvitePanelWeb, null),
                _notificationsVisible && !_isAnyOverlayVisible && (_overflowDrawer
                    ? React.createElement(JitsiPortal, { className: 'notification-portal' }, this.renderNotificationsContainer({ portal: true }))
                    : this.renderNotificationsContainer()),
                React.createElement(CalleeInfoContainer, null),
                isVrsApp() && this.props._accountRole === 'interpreter' && !_showPrejoin && !_showLobby && (React.createElement(PhoneNumpad, { onCall: this._handleMakeCall, onHangup: this._handleHangupCall, onSendDigits: this._handleSendDigits, onLeaveVoicemail: this._handleLeaveVoicemail, callStatus: this.state.callStatus, connectionMessage: this.state.connectionMessage, hangupPending: this.state.hangupPending, callError: this.state.callError, callDuration: this.state.callDuration, canLeaveVoicemail: !this.props._vrsVideoMailRelay
                        && Boolean(this.props._voicemailTarget?.calleeId || this.props._voicemailTarget?.calleePhone), initialPhoneNumber: this.props._vrsVideoMailRelay ? undefined : this.props._vrsTargetPhone, initiallyExpanded: Boolean(!this.props._vrsVideoMailRelay
                        && this.props._vrsTargetPhone
                        && this.state.callStatus === 'idle'), voicemailTargetName: this.props._voicemailTarget?.calleeName, vcoEnabled: this.props._vcoEnabled, vcoRoomName: this.props._room })),
                _showPrejoin && React.createElement(Prejoin, null),
                _showLobby && React.createElement(LobbyScreen, null)),
            !useVrsLayout && React.createElement(ParticipantsPane, null),
            React.createElement(ReactionAnimations, null),
            isLanguageQuickSwitchEnabled() && !_showPrejoin && !_showLobby && (React.createElement("div", { style: {
                    // Logical inset so the control moves to the left
                    // edge under RTL instead of covering the same
                    // corner in both directions.
                    insetInlineEnd: '20px',
                    position: 'fixed',
                    top: '16px',
                    zIndex: 1000
                } },
                React.createElement(LanguageSwitcher, null))),
            this.props._vcoEnabled && this.props._accountRole !== 'interpreter' && !_showPrejoin && !_showLobby && (React.createElement("div", { style: { position: 'fixed', right: 20, left: 20, bottom: 88, zIndex: 1000,
                    display: 'flex', justifyContent: 'flex-end', pointerEvents: 'none' } },
                React.createElement("div", { style: { pointerEvents: 'auto', width: '100%', maxWidth: 300 } },
                    React.createElement(VcoAudioControls, { role: "consumer", roomName: this.props._room })))),
            this.props._accountRole && !_showPrejoin && !_showLobby && (React.createElement(React.Fragment, null,
                React.createElement(QueueStatusIndicator, null),
                React.createElement(InMeetingRequestNotification, null),
                this.props._accountRole === 'interpreter' && !interpreterWorkspace && React.createElement(InterpreterStatusToggle, null),
                this.props._accountRole === 'interpreter' && !interpreterWorkspace && React.createElement(QueueStatsDashboard, null),
                React.createElement(HandoffProgress, null),
                React.createElement(HandoffVideoProbe, null),
                this.props._accountRole === 'interpreter' && React.createElement(InterpreterHandoffNotification, null)))));
    }
    /**
     * Handler for making VRS phone calls
     */
    async _handleMakeCall(phoneNumber) {
        console.log(`Making VRS call to: ${phoneNumber}`);
        const answerHeldInbound = this.props._vrsRequestKind === 'inbound_hearing'
            && phoneNumber === this.props._vrsTargetPhone;
        const success = await twilioVoiceService.makeCall({
            answerHeldInbound,
            phoneNumber,
            platformCallId: this.props._vrsPlatformCallId,
            // The raw room id — the title-cased _roomName contains spaces and
            // fails the server's session validation before the phone number
            // is even considered.
            sessionId: this.props._room || `vrs-${Date.now()}`,
            vcoEnabled: this.props._vcoEnabled
        });
        if (!success) {
            console.error('Failed to initiate call');
        }
    }
    /**
     * Handler for hanging up VRS phone calls
     */
    async _handleHangupCall() {
        try {
            await twilioVoiceService.hangupCall();
        }
        catch {
            // The service emits the retained failure and retry target to this panel.
            console.warn('Phone hangup remains unconfirmed; the End control is available for retry.');
        }
    }
    async _joinVcoBridge() {
        try {
            await twilioVoiceService.joinVcoBridge({
                role: this.props._accountRole === 'interpreter' ? 'interpreter' : 'consumer',
                roomName: this.props._room
            });
        }
        catch (error) {
            console.error('Failed to join VCO audio bridge:', error);
        }
    }
    _handleSendDigits(digits) {
        twilioVoiceService.sendDigits(digits);
    }
    /**
     * Starts an interpreter-origin VideoMail draft for the current VRS client.
     */
    async _handleLeaveVoicemail() {
        const target = this.props._voicemailTarget;
        if (!target?.calleeId && !target?.calleePhone) {
            console.warn('Unable to start VideoMail without a target client');
            return;
        }
        let storedBeforeNavigation = null;
        let preserveArmed = false;
        try {
            const result = await startVoicemailRecording({
                calleeId: target.calleeId,
                calleePhone: target.calleePhone
            });
            this.props.dispatch(recordingStarted({
                calleeId: target.calleeId,
                calleeName: target.calleeName,
                calleePhone: target.calleePhone,
                messageId: result.messageId,
                roomName: result.roomName,
                maxDurationSeconds: result.maxDurationSeconds
            }));
            if (this.props._vrsRequestKind === 'inbound_hearing') {
                storedBeforeNavigation = getPersistentJson('vrs_active_call');
                setPersistentItem('vrs_active_call', JSON.stringify({
                    ...(storedBeforeNavigation || {}),
                    callId: this.props._vrsPlatformCallId,
                    clientId: target.calleeId,
                    clientName: target.calleeName,
                    requestKind: this.props._vrsRequestKind,
                    roomName: result.roomName,
                    videoMailRelay: true
                }));
                twilioVoiceService.preserveCurrentCallForNavigation();
                preserveArmed = true;
            }
            try {
                const navigationSucceeded = await Promise.resolve(this.props.dispatch(appNavigate(result.roomName, {
                    hidePrejoin: true,
                    startWithAudioMuted: false,
                    startWithVideoMuted: false
                })));
                if (navigationSucceeded === false) {
                    throw new Error('Could not join the VideoMail room.');
                }
            }
            catch (error) {
                if (this.props._vrsRequestKind === 'inbound_hearing') {
                    if (storedBeforeNavigation) {
                        setPersistentItem('vrs_active_call', JSON.stringify(storedBeforeNavigation));
                    }
                    else {
                        removePersistentItem('vrs_active_call');
                    }
                }
                throw error;
            }
        }
        catch (error) {
            if (preserveArmed) {
                twilioVoiceService.cancelPreserveCurrentCallForNavigation();
            }
            this.props.dispatch({
                type: 'VOICEMAIL_ERROR',
                error: error instanceof Error ? error.message : 'Failed to start VideoMail'
            });
        }
    }
    /**
     * Handler for Twilio call status changes
     */
    _handleStatusChange(callStatus) {
        this.setState({ callStatus: callStatus.status, callError: callStatus.error, connectionMessage: callStatus.connectionMessage, hangupPending: Boolean(callStatus.hangupPending) });
    }
    /**
     * Handler for call duration updates
     */
    _handleDurationUpdate(duration) {
        this.setState({ callDuration: duration });
    }
    /**
     * Uses the authenticated Maple/Malka account name as the Jitsi chat nickname.
     *
     * @returns {void}
     */
    _syncAuthenticatedDisplayName() {
        const name = this.props._authenticatedDisplayName?.trim();
        if (name) {
            this.props.dispatch(updateSettings({ displayName: name }));
        }
    }
    /**
     * Sets custom background opacity based on config. It also applies the
     * opacity on parent element, as the parent element is not accessible directly,
     * only though it's child.
     *
     * @param {Object} element - The DOM element for which to apply opacity.
     *
     * @private
     * @returns {void}
     */
    _setBackground(element) {
        if (!element) {
            return;
        }
        if (this.props._backgroundAlpha !== undefined) {
            const elemColor = element.style.background;
            const alphaElemColor = setColorAlpha(elemColor, this.props._backgroundAlpha);
            element.style.background = alphaElemColor;
            if (element.parentElement) {
                const parentColor = element.parentElement.style.background;
                const alphaParentColor = setColorAlpha(parentColor, this.props._backgroundAlpha);
                element.parentElement.style.background = alphaParentColor;
            }
        }
    }
    /**
     * Handler used for touch start on Video container.
     *
     * @private
     * @returns {void}
     */
    _onVidespaceTouchStart() {
        this.props.dispatch(toggleToolboxVisible());
    }
    /**
     * Updates the Redux state when full screen mode has been enabled or
     * disabled.
     *
     * @private
     * @returns {void}
     */
    _onFullScreenChange() {
        this.props.dispatch(fullScreenChanged(APP.UI.isFullScreen()));
    }
    /**
     * Triggers iframe API mouseEnter event.
     *
     * @param {MouseEvent} event - The mouse event.
     * @private
     * @returns {void}
     */
    _onMouseEnter(event) {
        APP.API.notifyMouseEnter(event);
    }
    /**
     * Triggers iframe API mouseLeave event.
     *
     * @param {MouseEvent} event - The mouse event.
     * @private
     * @returns {void}
     */
    _onMouseLeave(event) {
        APP.API.notifyMouseLeave(event);
    }
    /**
     * Triggers iframe API mouseMove event.
     *
     * @param {MouseEvent} event - The mouse event.
     * @private
     * @returns {void}
     */
    _onMouseMove(event) {
        APP.API.notifyMouseMove(event);
    }
    /**
     * Displays the toolbar.
     *
     * @private
     * @returns {void}
     */
    _onShowToolbar() {
        this.props.dispatch(showToolbox());
    }
    /**
     * Until we don't rewrite UI using react components
     * we use UI.start from old app. Also method translates
     * component right after it has been mounted.
     *
     * @inheritdoc
     */
    _start() {
        APP.UI.start();
        APP.UI.registerListeners();
        APP.UI.bindEvents();
        FULL_SCREEN_EVENTS.forEach(name => document.addEventListener(name, this._onFullScreenChange));
        const { dispatch, t } = this.props;
        dispatch(init());
        maybeShowSuboptimalExperienceNotification(dispatch, t);
    }
}
/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code Conference} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const { backgroundAlpha, mouseMoveCallbackInterval } = state['features/base/config'];
    const { overflowDrawer } = state['features/toolbox'];
    const roomRole = state['features/base/jwt']?.user?.role;
    // This is a UI/side-effect boundary, not token verification or API authority.
    const accountRole = hasPersistentAuthToken() && roomRole !== 'guest' && roomRole !== 'observer'
        ? getUserRole() : null;
    const matchData = accountRole ? state['features/interpreter-queue']?.matchData : undefined;
    const storedActiveCall = accountRole ? getPersistentJson('vrs_active_call') : null;
    const storedUser = accountRole ? getPersistentJson('vrs_user_info') : null;
    const currentRoom = decodeURIComponent(state['features/base/conference'].room || '');
    const currentMatch = matchData?.roomName === currentRoom ? matchData : undefined;
    const currentStoredCall = storedActiveCall?.roomName === currentRoom ? storedActiveCall : undefined;
    const videoMailRelay = Boolean(currentStoredCall?.videoMailRelay);
    const activeMatch = videoMailRelay ? undefined : currentMatch;
    const activeStoredCall = videoMailRelay ? undefined : currentStoredCall;
    const calleeId = activeMatch?.clientId || activeStoredCall?.clientId;
    const calleeName = activeMatch?.clientName || activeStoredCall?.clientName;
    return {
        ...abstractMapStateToProps(state),
        _accountRole: accountRole,
        // Read on every store change (window resizes dispatch CLIENT_RESIZED),
        // so the docking follows the viewport without feeding back into it.
        _dockInterpreterChat: shouldDockInterpreterChat(getWindowWidth()),
        _backgroundAlpha: backgroundAlpha,
        _isAnyOverlayVisible: Boolean(getOverlayToRender(state)),
        _layoutClassName: LAYOUT_CLASSNAMES[getCurrentLayout(state) ?? ''],
        _mouseMoveCallbackInterval: mouseMoveCallbackInterval,
        _overflowDrawer: overflowDrawer,
        _room: currentRoom,
        _roomName: getConferenceNameForTitle(state),
        _showLobby: getIsLobbyVisible(state),
        _showPrejoin: isPrejoinPageVisible(state),
        _authenticatedDisplayName: storedUser?.name
            || storedUser?.displayName
            || storedUser?.username
            || storedUser?.email,
        _vrsTargetPhone: videoMailRelay ? undefined : activeMatch?.targetPhone || activeStoredCall?.targetPhone,
        _vrsPlatformCallId: activeMatch?.callId || activeStoredCall?.callId,
        _vrsRequestKind: activeMatch?.requestKind || activeStoredCall?.requestKind,
        _vrsVideoMailRelay: videoMailRelay,
        _audioMuted: isAudioMuted(state),
        _vrsCallType: activeMatch?.callType || activeStoredCall?.callType,
        _vcoEnabled: Boolean(activeMatch?.vcoEnabled ?? currentStoredCall?.vcoEnabled),
        _voicemailTarget: calleeId
            ? {
                calleeId,
                calleeName
            }
            : undefined
    };
}
export default reactReduxConnect(_mapStateToProps)(translate(Conference));
